// Return correct URL on server and client respectively
export default function getCmsUrl () {
    // TODO: return correct URL for production and development
    return process.env.REACT_APP_CMS_URL || 'https://matkasuvilad-api.vdisain.eu';
}
